<template>
  <div>
      <v-app class="p-4">
         <div>
             <similar-ads :taze="true" ref="newsAdds"></similar-ads>
         </div>
          <div v-if="AuthIs" class="row">
              <div class="col-md-8 mx-auto">
                  <v-text-field outlined clearable label="عنوان"
                                dense clear-icon="mdi-close-circle-outline"
                                append-inner-icon="fa fa-pencil-alt"
                                v-model="newSchema.title"
                                :error-messages="newSchema.title === '' ? 'تا زمانیکه عنوان وارد نشود قادر به ثبت دسته خود نیستید!' : ''"
                  >
                  </v-text-field>
              </div>
          </div>
         <div class="row">
            <div class="col-md-8 mr-auto">
                <v-btn :disabled="!AuthIs" class="float-left submit-btn"
                       @click="submit">
                    <span class="fa fa-save ml-2 " style="font-size: 1.5rem"></span>
                    ثبت
                </v-btn>
            </div>
         </div>
      </v-app>
  </div>
</template>

<script>
import SimilarAds from "./similarAds";
import {Bus} from "../../../../main";

export default {
    name: "divarNews",
    components: { SimilarAds},
    data() {
        return {
            AuthIs: false,
            nickName: '',
            newSchema: {
                title:'',
                search_payload: {},
            },
        }
    },
    methods: {
        submit() {
            const data = this.newSchema
            // if (this.$refs.newsAdds.$refs.city.validate())
            //     return;

            $.ajax({
                url: `${url}/user/recent`,
                method: 'POST',
                fn: this.submit,
                headers: {
                    ACCEPT: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: Token
                },
                data: JSON.stringify(data),
                msg:true,
                redirect: {path: "/adsList/divarNews/list"}
            });
        }
    },
    mounted() {
        Bus.$on('correctAuth', (value) => {
            this.AuthIs = value
        });

        Bus.$on('Authenticate', (value) => {
            this.AuthIs = value.length > 0
        });
        Bus.$on('getSimilarData', (value) => {
            this.newSchema.search_payload = value
        });

    },
}
</script>

<style scoped>

</style>